/* lua.js generated code 0.3.0 */

var Director = cc.Director
var callbacks = sTable()
Director.prototype.registerSceneEventListener = function (callback) {
    if (!table.indexof(callbacks, callback)) {
        table.insert(callbacks, callback)
    }
}
Director.prototype.unregisterSceneEventListener = function (callback) {
    table.removebyvalue(callbacks, callback)
}
var pushScene = Director.prototype.pushScene
Director.prototype.pushScene = function (scene) {
    var self = this
    pushScene.call(self, scene)
    var oldScene = self.getRunningScene()
    for (var i = 1, v = callbacks[1]; v; i++, v = callbacks[i]) {
        v("pushScene", oldScene, scene)
    }
}
// TODO: check
var replaceScene = Director.prototype.runScene
Director.prototype.replaceScene = function (scene) {
    var self = this
    replaceScene.call(self, scene)
    var oldScene = self.getRunningScene()
    for (var i = 1, v = callbacks[1]; v; i++, v = callbacks[i]) {
        v("replaceScene", oldScene, scene)
    }
}
var popScene = Director.prototype.popScene
Director.prototype.popScene = function () {
    var self = this
    for (var i = 1, v = callbacks[1]; v; i++, v = callbacks[i]) {
        v("beforePopScene", oldScene)
    }
    popScene.call(self)
    var oldScene = self.getRunningScene()
    for (var i = 1, v = callbacks[1]; v; i++, v = callbacks[i]) {
        v("popScene", oldScene)
    }
}
